@if (showsToast) {
<div class="toast__container">
  <div class="toast__icon">
    <img src="../../../assets/verify.svg" alt="" />
  </div>
  <div class="toast__text">{{ title }}</div>
  <img (click)="close()" class="toast__cancelIcon" src="../../../assets/icons8-cancel.svg" alt="" />
</div>
}